import muiIcons from "../../../components/icons/mui-icons";

export const sideCardData = [
  {
    name: "Backups",
    subName: "Total: 12",
    Icon: muiIcons.ServerIcon,
    color: "#663399",
  },
  {
    name: "Databases",
    subName: "Total: 12",
    Icon: muiIcons.DatabaseIcon,
    color: "#2196f3",
  },
  {
    name: "Space Used",
    subName: "Total: 160GB",
    Icon: muiIcons.InboxIcon,
    color: "#4caf50",
  },
  {
    name: "Downloaded",
    subName: "Total: 30GB",
    Icon: muiIcons.DownloadIcon,
    color: "#ffc107",
  },
];

export const tableData = [
  {
    title: "Wireless Bluetooth V4.0",
    photoUrl: "/assets/images/products/shows-small-img.png",
    status: "Cancel",
    created: "28 Nov 20",
    progress: 35,
  },
  {
    title: "Ray Ban Sunglass",
    photoUrl: "/assets/images/products/sunglass.png",
    status: "Pending",
    created: "28 Nov 20",
    progress: 50,
  },
  {
    title: "Wireless Bluetooth V4.0",
    photoUrl: "/assets/images/products/shows-small-img.png",
    status: "Success",
    created: "28 Nov 20",
    progress: 80,
  },
  {
    title: "Ray Ban Sunglass",
    photoUrl: "/assets/images/products/sunglass.png",
    status: "Success",
    created: "28 Nov 20",
    progress: 80,
  },
];

export const activityTimeLineData = [
  {
    name: "Client Meeting",
    created: "25 mins ago",
    Icon: muiIcons.PlusIcon1,
    details: "Bonbon macaroon jelly beans gummi bears lollipop",
  },
  {
    name: "Client Meeting",
    created: "25 mins ago",
    Icon: muiIcons.PowerIcon1,
    details: "Bonbon macaroon jelly beans gummi bears lollipop",
  },
  {
    name: "Client Meeting",
    created: "25 mins ago",
    Icon: muiIcons.CheckMarkIcon,
    details: "Bonbon macaroon jelly beans gummi bears lollipop",
  },
  {
    name: "Client Meeting",
    created: "25 mins ago",
    Icon: muiIcons.FaceIcon,
    details: "Bonbon macaroon jelly beans gummi bears lollipop",
  },
  // {
  //   name: 'Client Meeting',
  //   created: '25 mins ago',
  //   Icon: muiIcons.StarIcon,
  //   details: 'Bonbon macaroon jelly beans gummi bears lollipop',
  // },
];
